import { useForm } from 'react-hook-form';
import styles from './SetAppointmentType.module.scss';
import { DatePicker } from '../../../../ui/components/DatePicker/DatePicker';

export const SetAppointmentType = () => {
  const { register, setValue } = useForm({});
  return (
    <div className={styles.root}>
      <DatePicker
        register={register}
        setValue={setValue}
        name="date"
        firstDateAvailable={new Date()}
        lastDateAvailable={new Date()}
      />
    </div>
  );
};
